import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { auth, firestore } from "../firebase";
import "../styles/style.css";
import TextField from "@mui/material/TextField";
import NavbarDashboard from "../components/Navbar/NavbarDashboard";

function EditUsername() {
  const [email, setEmail] = useState("");
  const [user, loading, error] = useAuthState(auth);
  const [editedName, setEditedName] = useState("");
  const navigate = useNavigate();

  const handleChangeUsername = () => {
    if (user) {
      const userId = user.uid;

      // Update the display name in Firebase Authentication
      auth.currentUser
        .updateProfile({
          displayName: editedName,
        })
        .then(() => {
          console.log("Username updated successfully!");

          // Update the user's name in Firestore
          firestore.collection("users").doc(userId).update({
            name: editedName,
          });

          // You may want to add additional logic or redirect the user to another page.
        })
        .catch((error) => {
          console.error("Error updating username:", error.message);
        });
    }
  };

  useEffect(() => {
    if (loading) return;
    if (user) navigate("/editusername");
  }, [user, loading]);

  return (
    <div className="login_body">
      <NavbarDashboard />

      <div className="login">
        <div className="login-header">
          <h3>Please enter your desired name in the field below.</h3>
          <div className="login_container">
            <TextField
              fullWidth
              id="outlined-textarea"
              className="login_textBox"
              type="text"
              value={editedName}
              onChange={(e) => setEditedName(e.target.value)}
              placeholder="Enter new username"
              size="normal"
              margin="normal"
              multiline
            />
            <br />
            <button className="login_btn" onClick={handleChangeUsername}>
              Change Username
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default EditUsername;
